import * as z from "zod/v4";

export const adminSendTestText = {
  name: "adminSendTestText" as const,
  input: z.object({
    teamId: z.string(),
    toPhoneNumber: z.string().min(1),
    message: z.string().min(1).max(1600),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
